import React from 'react'
import styled from 'styled-components'
import { Borders, Colors, FontWeights } from '../../constants'
import { useSettings } from '../../providers'
import { logAmplitudeEvent } from '../../utils'

interface Props {
  className?: string
}

export function SuggestedDepositButton({ className }: Props) {
  const { settings, setSettings } = useSettings()

  function setSuggested() {
    setSettings({ ...settings, useSuggestedDeposit: true })
  }

  function setCustom() {
    setSettings({ ...settings, useSuggestedDeposit: false })
  }

  return (
    <Container className={className}>
      <ButtonLeft
        title="Deposit using suggested ratio"
        onClick={() => {
          setSuggested()
          logAmplitudeEvent('Deposit: Click Suggested Ratio')
        }}
        active={settings.useSuggestedDeposit}
      >
        Suggested Ratio
      </ButtonLeft>
      <ButtonRight
        title="Deposit using a custom ratio"
        onClick={() => {
          setCustom()
          logAmplitudeEvent('Deposit: Click Custom Ratio')
        }}
        active={!settings.useSuggestedDeposit}
      >
        Custom Ratio
      </ButtonRight>
    </Container>
  )
}

const Container = styled.div`
  margin-bottom: 20px;
  padding: 0 20px;
  display: flex;
`

const Button = styled.button<{ active?: boolean }>`
  margin: 0;
  padding: 5px 0;
  flex-basis: 50%;
  color: ${({ active }) => (active ? Colors.Black : Colors.DarkerGray)};
  font-size: 11px;
  font-weight: ${FontWeights.Bold};
  text-transform: uppercase;
  border: 1px solid ${Borders.Color};
  border-radius: ${Borders.Radius};
  background-color: ${({ active }) => (active ? 'transparent' : Colors.LightestGray)};
  cursor: pointer;
  outline: none;

  &:hover {
    color: ${Colors.Hover};
  }
`

const ButtonLeft = styled(Button)`
  border-radius: ${Borders.Radius} 0 0 ${Borders.Radius};
`

const ButtonRight = styled(Button)`
  border-radius: 0 ${Borders.Radius} ${Borders.Radius} 0;
  border-left: 0;
`
